import classNames from 'classnames';

import classes from './Checkbox.module.css';
import useTranslation from 'next-translate/useTranslation';

type CheckboxProps = {
   id?: string;
   name?: string;
   value?: boolean;
   label: string | JSX.Element;
   onChangeHandler?: (event: React.ChangeEvent<HTMLInputElement>) => void;
   onClick?: () => void;
   error?: boolean;
   className?: string;
   inputGroup?: boolean;
   disabled?: boolean;
   readonly?: boolean;
};

const Checkbox = ({
   id,
   name,
   value,
   label,
   onChangeHandler,
   onClick,
   error,
   className,
   inputGroup,
   disabled,
   readonly,
}: CheckboxProps) => {
   const { t } = useTranslation('common');
   return (
      <div
         {...(onClick && { onClick })}
         className={classNames(className, {
            [classes.checkbox]: true,
            [classes.error]: error,
            [classes.inputGroup]: inputGroup,
            [classes.disabled]: disabled,
         })}
      >
         <input
            id={id}
            type="checkbox"
            name={name}
            checked={value}
            onChange={onChangeHandler}
            readOnly={readonly}
            disabled={disabled}
         />
         <label htmlFor={id}>{typeof label === 'string' ? t(label) : label}</label>
      </div>
   );
};

export default Checkbox;
